import { useLocation, useNavigate } from "react-router-dom";
import { BarChart3, Calendar, ListChecks, User, House } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const navItems = [
  { key: "dashboard", icon: House, path: "/athlete/dashboard" },
  { key: "schedule", icon: Calendar, path: "/athlete/schedule" },
  { key: "reservations", icon: ListChecks, path: "/athlete/reservations" },
  { key: "stats", icon: BarChart3, path: "/athlete/stats" },
  { key: "userProfile", icon: User, path: "/athlete/profile" },
];

export function BottomNavBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation("athlete");

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <div className="absolute inset-0 border-t border-border/70 bg-background/90 backdrop-blur-xl" />

      <div className="relative bg-background">
        <div className="flex h-14 items-center justify-around px-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.key}
                onClick={() => navigate(item.path)}
                className={cn(
                   "flex flex-1 min-w-0 flex-col items-center justify-center gap-0.5 px-1.5 py-1 transition-all duration-300",
                  "touch-manipulation select-none",
                  isActive
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                )}
                aria-current={isActive ? "page" : undefined}
                aria-label={t(`tabs.${item.key}`)}
              >
                <div className={cn(
                   "relative flex h-6 w-8 items-center justify-center transition-all duration-300",
                   isActive && "text-primary"
                )}>
                  <item.icon className={cn(
                    "h-[18px] w-[18px] transition-all duration-300",
                    isActive && "scale-110"
                  )} />
                  {isActive && (
                    <span className="absolute -bottom-0.5 h-1 w-1 rounded-full bg-primary" />
                  )}
                </div>
                <span className={cn(
                  "max-w-[3.5rem] truncate text-center text-[9px] font-medium leading-tight",
                  isActive && "font-semibold"
                )}>
                  {t(`tabsShort.${item.key}`)}
                </span>
              </button>
            );
          })}
        </div>

        <div
          aria-hidden="true"
          className="bg-background"
          style={{ height: "env(safe-area-inset-bottom, 0px)" }}
        />
      </div>
    </nav>
  );
}
